<ng-container *ngIf="component.data$ | async as data">
  <p [innerHTML]="sanitizer.bypassSecurityTrustHtml(data.content)"></p>
</ng-container>
